import React, { useState } from "react";
import { CiFilter } from "react-icons/ci";
import { FaCheck } from "react-icons/fa"; // Ensure you have react-icons installed
import { RxCross1 } from "react-icons/rx";
import {
  CalculateExtraWage,
  // calculateTimeDifference,
  formatNumberWithCommas,
  SumationExtraHour,
  SumationHour,
  SumationLeavingRequestHour,
  TotalDailyWage,
} from "../../Actions/TimeControll";

const Table = ({ children, columns, attendances, tfoot = false }) => {
  return (
    <div className="overflow-auto">
      <table className="p-2 w-full =  rounded-md shadow-md">
        <TableHead columns={columns} />

        <tbody className="p-2">{children}</tbody>
        {tfoot && <TableFotter attendances={attendances} />}
      </table>
    </div>
  );
};

const TableFotter = ({ attendances }) => {
  let users = [];

  attendances?.map((atten) => {
    users = atten?.user;
  });
  return (
    <tfoot className="sticky border bottom-0">
    <tr className="p-3 bg-gray-300 text-slate-900 font-bold border ">
      <td className="p-3  border text-center" colSpan={6}>
        Totals
      </td>
      <td className="p-3 border text-center">{SumationHour(attendances)}</td>

      <td className="p-3 border text-center">
        {/* {totals.totalApproveTime[0]}h {totals.totalApproveTime[1]}m */}

        {SumationExtraHour(attendances)}
      </td>
      <td className="p-3 border text-center">
        {/* {totals.totalApproveTime[0]}h {totals.totalApproveTime[1]}m */}

        {SumationLeavingRequestHour(attendances)}
      </td>
      <td className="p-3 border text-center">
        {/* {totals.totalApproveTime[0]}h {totals.totalApproveTime[1]}m */}
        {formatNumberWithCommas(CalculateExtraWage(users,attendances))} IQD
      </td>

      {/* leave Request */}

      <td className="p-3 border text-center">
        {/* {totals.totalApproveTime[0]}h {totals.totalApproveTime[1]}m */}
        {formatNumberWithCommas(TotalDailyWage(users,attendances))} IQD
      </td>
      <td></td>
    </tr>
  </tfoot>
  );
};
const TableHead = ({ columns }) => {
  const [indexx, setIndexx] = useState(null);
  // console.log(columns)
  return (
    <thead className="sticky top-0    ">
      <tr>
        {columns?.map((header, index) => (
          <th
            key={index}
            className=" bg-gray-800 border relative text-white text-left"
          >
            <div className="flex justify-between items-center">
              {header}
              <p
                onClick={() => setIndexx(index)}
                className="text-xl cursor-pointer hover:bg-gray-900 duration-500 bg-gray-700 rounded-md shadow-md  p-2"
              >
                <CiFilter />
              </p>
            </div>
            {index == indexx && (
              <div className="absolute top-8 left-0 bg-white/30 backdrop-blur-3xl  rounded-md shadow-xl p-2 w-full">
                <input
                  type="text"
                  className="input w-full"
                  placeholder={header}
                />
                <div className="flex gap-2 mt-2">
                  <button className="btn-indigo">
                    <FaCheck />
                  </button>
                  <button onClick={() => setIndexx(null)} className="btn-red">
                    <RxCross1 />
                  </button>
                </div>
              </div>
            )}
          </th>
        ))}
        <th
          // key={index}
          className=" bg-gray-800 border relative text-white text-left"
        >
          {" "}
          Action
        </th>
      </tr>
    </thead>
  );
};

export default Table;
